<script>
import { mapGetters, mapActions } from 'vuex'
import get from 'lodash/get'
import RetailerDetails from './details/retailer-details'
import RetailerEdit from './edit/retailer-edit'

export default {
  name: 'Retailer',
  page: {
    title: 'Retailer',
  },
  components: {
    RetailerDetails,
    RetailerEdit,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      retailer: null,
      provider: null,
      backRoute: { name: 'retailers' },
    }
  },
  computed: {
    ...mapGetters('me', [
      'canUpdateRetailer',
      'canUpdateOffer',
      'canCreateOffer',
    ]),
    isEdit() {
      return this.$route.name === 'retailer-edit'
    },
    retailerName() {
      return get(this.retailer, 'name')
    },
    back() {
      if (this.isEdit) {
        return {
          name: 'retailer-details',
          params: {
            id: this.id,
            edit: null,
          },
        }
      } else {
        return this.backRoute
      }
    },
  },
  async created() {
    this.loading = true

    await this.fetchRetailer()
    await this.fetchProvider()

    this.loading = false
  },
  methods: {
    ...mapActions('retailer', [
      'getRetailer',
    ]),
    ...mapActions('providers', {
      getProvider: 'GET_PROVIDER',
    }),
    async fetchRetailer() {
      const [err, response] = await this.getRetailer(this.id)

      if (err) {
        this.$router.replace(this.backRoute)
      } else {
        this.retailer = response
      }
    },
    async fetchProvider() {
      if (this.retailer.providerId) {
        const [error, response] = await this.getProvider(this.retailer.providerId)

        if (!error) {
          this.provider = response
        }
      }
    },
    async updateRetailer() {
      this.loading = true
      await this.fetchRetailer()
      this.loading = false
    },
    onEdit() {
      this.$router.push({
        name: 'retailer-edit',
      })
    },
    onCancel() {
      this.$router.push({
        name: 'retailer-details',
      })
    },
    onManage() {
      this.$router.push({
        name: 'retailer-offers',
      })
    },
  },
}
</script>

<template>
  <main-layout
    :title="retailerName"
    :loading="loading"
    :back="back"
  >
    <retailer-edit
      v-if="isEdit"
      :retailer="retailer"
      @update="updateRetailer"
      @cancel="onCancel"
    />
    <data-box
      v-else
      :status="false"
      header="Retailer Details"
    >
      <div
        slot="buttons"
        :class="$style.headerButtons"
      >
        <el-button
          v-if="canUpdateRetailer"
          type="primary"
          plain
          :class="$style.headerButton"
          @click="onEdit"
        >
          Edit Details
        </el-button>
        <el-button
          v-if="canUpdateOffer || canCreateOffer"
          type="primary"
          plain
          :class="$style.headerButton"
          @click="onManage"
        >
          Manage offers
        </el-button>
      </div>
      <retailer-details
        :retailer="retailer"
        :provider="provider"
      />
    </data-box>
  </main-layout>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.headerButtons {
  display: flex;
  flex-direction: column;
  margin: rem(-8px);
  margin-bottom: rem(-64px)
}

.headerButton {
  margin: rem(8px) !important;
}
</style>
